import {domainParser, subDomainParser} from './UrlParser'

let defaultConfig = {
  secure: false,
}

/**
 * Generate a string with automatic baseUrl resolution.
 *
 * @param subdomain
 * @param secure
 * @returns string
 */
let urlFactory = function (subdomain, secure = false) {
  let protocol = window.location.protocol

  // Force https manually, otherwise use default
  if(secure) {
    protocol = 'https:'
  }

  return  protocol + '//' + subdomain + domainParser() + '/'
}

const UrlGenerator = {
  install(Vue2, options) {
    let config = Object.assign(defaultConfig, options)

    Vue2.prototype.$urlGenerator = {
      public(uri = '') {
        return urlFactory('app', config.secure) + uri
      },
      superAdmin() {
        return urlFactory('system', config.secure)
      },
      active(uri = '') {
        return urlFactory(subDomainParser(), config.secure) + uri
      },
      forUnion(subdomain) {
        return urlFactory(subdomain, config.secure)
      },
    }
  },
}

export default UrlGenerator